import { motion, useScroll, useSpring } from "framer-motion";
import { HOME } from "@/constants/testIds";

// Thin glowing progress bar tracking scroll position through the whole page.
export const ScrollProgressBar = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 22, restDelta: 0.001 });

  return (
    <motion.div
      data-testid={HOME.scrollProgress}
      style={{ scaleX }}
      className="fixed left-0 right-0 top-0 z-[60] h-[3px] origin-left bg-brand-gradient shadow-glow-primary"
    />
  );
};
